import * as agreements from '@appStore/selfservice/actions/agreement.actions';
import * as forms from '@appStore/selfservice/actions/forms.actions';
import * as bookings from '@appStore/selfservice/actions/bookings.actions';

export * from '@appStore/selfservice/actions/agreement.actions';
export * from '@appStore/selfservice/actions/forms.actions';
export * from '@appStore/selfservice/actions/bookings.actions';

export const ActionTypes = {
  ...agreements.AgreementActionTypes, ...forms.FormsActionTypes, ...bookings.BookingActionTypes
};

export type Actions =
  | agreements.AgreementActions
  | forms.FormsActions
  | bookings.BookingActions;
